import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Instagram } from "lucide-react";
import { services } from "@/lib/services";

const shortLabel = (h1) =>
  h1
    .replace(/ στην Πάτρα| στην Ελλάδα/g, "")
    .replace(/^Ψυχολόγος για |^Ειδικός για /, "");
import { articles } from "@/lib/articles";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="border-t border-border/50 pt-20 pb-10 px-6 sm:px-12 lg:px-20 bg-background"
    >
      <div className="max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-14">
          {/* Brand */}
          <div className="md:col-span-4">
            <p className="font-heading text-3xl text-foreground tracking-tight">
              Άννα <span className="italic font-light">Παπαχρονόπουλου</span>
            </p>
            <p className="text-[11px] tracking-[0.22em] uppercase text-muted-foreground mt-2">
              Ψυχοθεραπεία · Πάτρα
            </p>
            <p className="mt-5 font-body font-light text-foreground/70 text-sm leading-relaxed max-w-[320px]">
              Ατομική ψυχοθεραπεία (CBT) για άγχος, OCD, αυτοεκτίμηση, σχέσεις
              και τραύμα. Δια ζώσης ή online.
            </p>
          </div>

          {/* Services */}
          <div className="md:col-span-3">
            <p className="text-[10px] tracking-[0.22em] uppercase text-muted-foreground font-medium mb-5">
              Υπηρεσίες
            </p>
            <ul className="space-y-2.5 font-body text-sm">
              {services.map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/ipiresies/${s.slug}`}
                    className="text-foreground/75 hover:text-foreground transition-colors"
                    data-testid={`footer-service-${s.slug}`}
                  >
                    {shortLabel(s.h1)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Articles */}
          <div className="md:col-span-3">
            <p className="text-[10px] tracking-[0.22em] uppercase text-muted-foreground font-medium mb-5">
              Άρθρα
            </p>
            <ul className="space-y-2.5 font-body text-sm">
              {articles.map((a) => (
                <li key={a.slug}>
                  <Link
                    to={`/arthra/${a.slug}`}
                    className="text-foreground/75 hover:text-foreground transition-colors line-clamp-1"
                    data-testid={`footer-article-${a.slug}`}
                  >
                    {a.title}
                  </Link>
                </li>
              ))}
              <li className="pt-1">
                <Link
                  to="/psixotherapeia-patra"
                  className="text-foreground hover:text-primary transition-colors font-medium"
                  data-testid="footer-psixotherapeia-link"
                >
                  Ψυχοθεραπεία στην Πάτρα →
                </Link>
              </li>
              <li className="pt-1">
                <Link
                  to="/arthra"
                  className="text-foreground hover:text-primary transition-colors font-medium"
                >
                  Όλα τα άρθρα →
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-2">
            <p className="text-[10px] tracking-[0.22em] uppercase text-muted-foreground font-medium mb-5">
              Επικοινωνία
            </p>
            <ul className="space-y-3 font-body text-sm">
              <li>
                <a
                  href="mailto:anniepapach@gmail.com"
                  className="inline-flex items-center gap-2 text-foreground/75 hover:text-foreground transition-colors"
                >
                  <Mail size={14} strokeWidth={1.5} />
                  Email
                </a>
              </li>
              <li>
                <a
                  href="tel:+306978042360"
                  className="inline-flex items-center gap-2 text-foreground/75 hover:text-foreground transition-colors"
                >
                  <Phone size={14} strokeWidth={1.5} />
                  697 8042 360
                </a>
              </li>
              <li className="flex items-start gap-2 text-foreground/75">
                <MapPin size={14} strokeWidth={1.5} className="mt-1 shrink-0" />
                <span>
                  Ρήγα Φεραίου 119
                  <br />
                  Πάτρα
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-border/50 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 font-body text-xs text-muted-foreground">
          <span>© {year} psyloveyourself.com — Όλα τα δικαιώματα διατηρούνται</span>
          <Link
            to="/politiki-aporritou"
            data-testid="footer-privacy-link"
            className="hover:text-foreground transition-colors underline underline-offset-4"
          >
            Πολιτική Απορρήτου
          </Link>
          <span className="italic font-heading text-foreground/60 text-base">
            psyloveyourself
          </span>
        </div>
      </div>
    </footer>
  );
}
